function storeSearch(map) {
  const $form = $(".stores .search-stores form");
  $(".stores .search-stores form").on("submit", function(e) {
    e.preventDefault();
    const $this = $(this);
    const inputValue = $this.find(".field").val();
    const radius = parseInt($this.data("radius"));
    const searchMarkers = [];
    const geocoder = new google.maps.Geocoder();
    let bounds = new google.maps.LatLngBounds();
    const $searchResults = $(".store-results");

    geocoder.geocode({ address: inputValue }, (results, status) => {
      if (status === "OK") {
        let markers = 0;
        let markersArray = [];

        // Push all the markers in the radius of the search in the bounds object
        mapMarkers.map(marker => {
          const latLng = new google.maps.LatLng(marker.location);
          const currentSearchLocation = results[0].geometry.location;
          const distance = google.maps.geometry.spherical.computeDistanceBetween(currentSearchLocation, latLng);
          if (distance < radius) {
            markers++;
            bounds.extend(marker.location);
            markersArray.push($(`a[data-target="${marker.target}"]`));
          }
        });

        // Check if there are any markers in the radius of the search and fit them in the map or set the map to the center of the search location
        if (markers > 0) {
          map.fitBounds(bounds);
        } else {
          map.setCenter(results[0].geometry.location);
        }

        $searchResults.show().find(".menu-deep-3").empty().prepend(`<li><h2>${markers} STORES IN YOUR AREA</h2></li>`);
        markersArray.map(ele => {
          $searchResults.find(".menu-deep-3").append("<li>" + ele.parent().html() + "</li>");
        });

        $(".store-locations").hide();
        $(".search-stores .current-location").add($(".enable-geocoding")).hide();
        $(".disable-geocoding").show();
      }
    });
  });
  if ($form.find(".field").val() != "") {
    $form.trigger("submit");
  }
}

module.exports = {
  storeSearch
};



// WEBPACK FOOTER //
// ../assets/js/map/store-search.js